import { ReactComponent as SelectAll } from 'assets/icons/icon-select-all.svg';

export default SelectAll;
